// Maximum file size of the FileAPI in mebibytes.
const MAX_FILE_SIZE_MIB = 50;
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MIB * 1024 * 1024;

type ValidateFileReturn = [isError: boolean, errorMessage: string];

/**
 * Helper function for validating a File before uploading to the FileAPI.
 */
export default function validateFile(file: File): ValidateFileReturn {
  if (file.size > MAX_FILE_SIZE_BYTES) {
    // Users may be confused by "MiB", so use "MB".
    return [false, `File size exceeds ${MAX_FILE_SIZE_MIB} MB limit`];
  }

  return [true, ""];
}
